<app-alert></app-alert>
<app-perfil-usuario-detalle *ngIf="validarEtapa(EnumEtapas.Detalles)" (eventoPadreCambiarEtapa)="onChangeEtapa($event)"
    [dataUsusario]="dataUsuario" [numberEtapas]="EnumEtapas"></app-perfil-usuario-detalle>
<app-perfil-usuario-modifi *ngIf="validarEtapa(EnumEtapas.Modifi)"  [numberEtapas]="EnumEtapas" [dataUsuario]="dataUsuario"
    (enventoAcualizarData)="actualizarPerfilUsuario($event)" (eventoPadreCambiarEtapa)="onChangeEtapa($event)"></app-perfil-usuario-modifi>
<app-perfil-usuario-change-ok *ngIf="validarEtapa(EnumEtapas.Ok)" [numberEtapas]="EnumEtapas"
    (eventoPadreCambiarEtapa)="onChangeEtapa($event)"></app-perfil-usuario-change-ok>

